export function fillMissingMonths(data, startDate = null, endDate = null) {
  if (data.length === 0 && !startDate && !endDate) {
    return [];
  }

  // Helper function to parse year and month from a string
  function parseYearAndMonth(monthStr) {
    if (monthStr.length !== 7) {
      throw new Error('Invalid month string format. Use "YYYY-MM"');
    }
    const year = parseInt(monthStr.slice(0, 4));
    const month = parseInt(monthStr.slice(5));
    return { year, month };
  }

  // Helper function to format the year and month back into a string
  function formatYearAndMonth(year, month) {
    return `${year}-${month.toString().padStart(2, "0")}`;
  }

  // Helper function to add months to a year-month structure
  function addMonths({ year, month }, numMonths) {
    month += numMonths;
    while (month > 12) {
      month -= 12;
      year++;
    }
    return { year, month };
  }

  // Helper function to get the year and month from a date string (YYYY-MM-DD)
  function getYearMonthFromDate(dateStr) {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    return { year, month };
  }

  // Parse startDate and endDate (if provided)
  const startMonth = startDate
    ? getYearMonthFromDate(startDate)
    : parseYearAndMonth(data[0][0]);
  const endMonth = endDate ? getYearMonthFromDate(endDate) : null;

  // Initialize a new array to hold the augmented data
  const augmentedData = [];

  // If data is empty and startDate/endDate is provided, fill the range
  if (data.length === 0 && startDate && endDate) {
    let currentMonth = startMonth;
    while (
      currentMonth.year < endMonth.year ||
      (currentMonth.year === endMonth.year &&
        currentMonth.month <= endMonth.month)
    ) {
      augmentedData.push([
        formatYearAndMonth(currentMonth.year, currentMonth.month),
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
      ]);
      currentMonth = addMonths(currentMonth, 1);
    }
    return augmentedData;
  }

  // Loop through the original data
  for (let i = 0; i < data.length; i++) {
    let currentMonth = parseYearAndMonth(data[i][0]);

    // Skip months before the start date
    if (
      currentMonth.year < startMonth.year ||
      (currentMonth.year === startMonth.year &&
        currentMonth.month < startMonth.month)
    ) {
      continue;
    }

    // Add the current row to the augmented data
    augmentedData.push(data[i]);

    // If it's not the last row, check for missing months
    if (i < data.length - 1) {
      let nextMonth = parseYearAndMonth(data[i + 1][0]);

      // Get previous totalClicks and totalButtons
      let canceledClicks = data[i][10];
      let clicksToPay = data[i][11];
      let previousTotalClicks = data[i][12];
      let previousTotalButtons = data[i][13];

      // Fill in missing months between the current and next month
      while (
        currentMonth.year !== nextMonth.year ||
        currentMonth.month < nextMonth.month
      ) {
        currentMonth = addMonths(currentMonth, 1);

        // If the next month matches, break the loop
        if (
          currentMonth.year === nextMonth.year &&
          currentMonth.month === nextMonth.month
        )
          break;

        // Add a new row for the missing month
        augmentedData.push([
          formatYearAndMonth(currentMonth.year, currentMonth.month),
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          canceledClicks,
          clicksToPay,
          previousTotalClicks,
          previousTotalButtons,
        ]);
      }
    }
  }

  // Handle missing months up to the end date or today
  let lastMonth = parseYearAndMonth(augmentedData[augmentedData.length - 1][0]);
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;

  let finalEndMonth = endMonth
    ? endMonth
    : { year: currentYear, month: currentMonth };
  let canceledClicks = augmentedData[augmentedData.length - 1][10];
  let clicksToPay = augmentedData[augmentedData.length - 1][11];
  let previousTotalClicks = augmentedData[augmentedData.length - 1][12];
  let previousTotalButtons = augmentedData[augmentedData.length - 1][13];

  while (
    lastMonth.year < finalEndMonth.year ||
    (lastMonth.year === finalEndMonth.year &&
      lastMonth.month < finalEndMonth.month)
  ) {
    lastMonth = addMonths(lastMonth, 1);

    augmentedData.push([
      formatYearAndMonth(lastMonth.year, lastMonth.month),
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      canceledClicks,
      clicksToPay,
      previousTotalClicks,
      previousTotalButtons,
    ]);
  }

  return augmentedData;
}
